import APIClient from './index';
import _ from 'lodash';

export const updateAnnouncement = (announcement, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/Announcements/${announcement.id}`, updates)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};
